import { makeStyles } from "tss-react/mui";
import { INSPECTION_STATUSES_CONFIG } from "@miplatform/constants";
import { IInspectionAttempt } from "@miplatform/types";
import { Box, Divider } from "@mui/material";
import { MiStackedTypography } from "../../MiStackedTypography/MiStackedTypography";

export const InspectionCardStatus = ({
  item,
}: {
  item: IInspectionAttempt;
}) => {
  const { classes } = useStyles();
  const { attemptStatus } = item;

  const { color } = INSPECTION_STATUSES_CONFIG[attemptStatus] || {};
  return (
    <Box className={classes.inspectionCardStatus}>
      <MiStackedTypography
        title="Status"
        description={attemptStatus}
        descriptionProps={{ color, fontWeight: 600 }}
      />
      <Divider orientation="vertical" />
    </Box>
  );
};
const useStyles = makeStyles()((theme) => ({
  inspectionCardStatus: {
    width: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));
